import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

type MessageProps = {
    role: 'user' | 'assistant';
    content: string;
};

type StyledProps = {
    role: 'user' | 'assistant';
};


const Message = ({ role, content }: MessageProps) => {
    return (
        <MessageContainer role={role}>
            <MessageBox role={role}>{content}</MessageBox>
        </MessageContainer>
    );
};

const messageStyles = {
    assistant: css`
        background-color: #f1f1f1;
        color: #000000;
        border-bottom-left-radius: 4px;
    `,
    user: css`
        background-color: #000000;
        color: #ffffff;
        border-bottom-right-radius: 4px;
    `,
};
const MessageContainer = styled.div<StyledProps>`
    display: flex;
    justify-content: ${({ role }) => (role === 'user' ? 'flex-end' : 'flex-start')};
    margin-bottom: 12px;
`;

const MessageBox = styled.div<StyledProps>`
    max-width: 90%;
    padding: 10px 14px;
    border-radius: 20px;
    white-space: pre-wrap;
    line-height: 1.5;
    font-size: 15px;
    word-break: break-word;

    ${({ role }) => messageStyles[role]}
`;

export default Message;
